<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import { Link } from "@inertiajs/vue3";

export default {
    name: "MobileMenuDropdownBlock",
    components: { Link, IconChevronDown },
    props: {
        btnText: {
            type: String,
            required: true,
        },
        route_name: {
            type: String,
            default: null,
        },
        route_params: {
            type: Object,
            default: () => ({}),
        },
        items: {
            type: Array,
            default: () => ([]),
        },
        forceOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.forceOpen,
        };
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
        },

        buildMenuLink(item) {
            if (item?.url) {
                return item.url;
            }

            if (!item?.route_name) {
                return "#";
            }

            const fullParams = item.route_params ?? {};
            const { query, ...pureRouteParams } = fullParams;

            let url = route(item.route_name, pureRouteParams);

            if (query && typeof query === "object") {
                const queryParams = new URLSearchParams();

                for (const [key, values] of Object.entries(query)) {
                    queryParams.append(key, JSON.stringify(values));
                }

                const queryString = queryParams.toString();
                if (queryString) {
                    url += `?${queryString}`;
                }
            }

            return url;
        },

        buildCurrentLink() {
            return this.buildMenuLink({
                route_name: this.route_name,
                route_params: this.route_params,
            });
        },
    },
};
</script>

<template>
    <div>
        <div class="grid grid-cols-12 p-2 ps-0 w-full text-base text-gray-900 rounded-lg transition duration-75 group">
            <template v-if="route_name">
                <Link
                    class="col-span-8 text-left font-medium"
                    :href="buildCurrentLink()"
                >
                    {{ btnText }}
                </Link>
            </template>

            <template v-else>
                <div
                    class="col-span-8 text-left font-medium"
                    @click.prevent="toggleOpen"
                >
                    {{ btnText }}
                </div>
            </template>

            <div
                class="flex items-center justify-end col-span-4"
                @click.prevent="toggleOpen"
            >
                <IconChevronDown
                    :rotate="isOpen"
                    class="w-5 h-5 transition-transform menu-chevron"
                />
            </div>
        </div>

        <ul v-if="isOpen" class="space-y-2 divide-y">
            <li
                v-for="(item, index) in items"
                :key="item.id ?? item.title ?? index"
                class="ms-5 pt-2"
            >
                <div v-if="item.sub_menu?.length">
                    <MobileMenuDropdownBlock
                        :btnText="item.title"
                        :items="item.sub_menu"
                        :route_name="item.route_name"
                        :route_params="item.route_params"
                    />
                </div>

                <div v-else>
                    <Link
                        :href="buildMenuLink(item)"
                        class="flex items-center p-2 ps-0 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group"
                    >
                        {{ item.title }}
                    </Link>
                </div>
            </li>
        </ul>
    </div>
</template>
